<template>
    <div
        class="list-client__container"
        v-if="canChange"
    >
        <modal
                v-show="isModal"
                @close="closeModal"
        >
            <template v-slot:modalBody>
                <form-add-client
                        v-if="isModal"
                        :name = "clientName"
                        @submitForm="onSubmitClientAdd"
                        @cancelForm="closeModal"
                />
            </template>
        </modal>
        <button
                class="list-client__item list-client__item_pointer"
                @click="onClickClientCreate"
        >
            Создать клиента
        </button>
        <table-settings
                :labels="labels"
                :rows="Object.keys(clients).length !== 0 ? clients : []"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                @editedCellInput="onChangeModel"
                @removeRow="onClickRemoveClient"
                @changeDropdown="onChangeDropdown"
        >

        </table-settings>

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import FormAddClient from "../../components/Forms/FormAddClient";
import Modal from '../../components/Base/Modal';
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsClients from '../../schemes/schemeSettingsClients';
let {
    routeClientEdit,
    routeClientAdd,
    routeClientRemove,
    routeClientSettings
} = schemeApi;
let {columnSettings, labels} = schemeSettingsClients;
export default {
    name: 'ViewSettingsClients',
    components: {
        TableSettings,
        FormAddClient,
        Modal
    },
    /**
     * Данные компонента
     * @property {array} clientList - список клиентов
     * @property {array} managerList - список менеджеров
     * @property {boolean} isEmptyClients проверка ответа на пустоту списка клиентов
     * @property {boolean} isEmptyUsers проверка ответа на пустоту списка пользователей
     * @property {boolean} isModal флаг открытия модального окна
     * @property {string} clientName название клиента
     * @property {number} clientId id клиента
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isGettingUserList флаг получения списка пользователей
     * @property {boolean} isUpdatingList флаг внесения изменений в список
     * @property {boolean} canChange флаг разрешения на возможность редактировать
     */
    data: () => ({
        clientList: [],
        isEmptyClients: false,
        isModal: false,
        clientName: '',
        clientId: null,

        isGettingList: false,
        isUpdatingList: false,
        canChange: false,

        clients: [],
        columnSettings: columnSettings,
        labels: labels,
      yOffset: null
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Клиенты");
        // получаем право на редактирование
        this.canChange = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
        if(this.canChange){
            this.getData();
        }
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getData() {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.post(routeClientSettings);
                this.clients = data.clients;
                this.columnSettings.contract_type.values = data.contracts;
                let selectedContracts = {};
                data.clients.forEach(client => {
                  selectedContracts[Number(client.id)] = [Number(client.contract_type)];
                })
              this.columnSettings.contract_type.selected = selectedContracts;
              if(this.yOffset !== null){
                setTimeout(() => {
                  console.log('скролл');
                  window.scroll(0,this.yOffset)
                }, 300)
              }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isUpdatingList || this.isGettingList;
        },
        /**
         * событие клика по кнопке создать клиента
         */
        onClickClientCreate() {
            this.isModal = true;
            this.clientId = null;
            this.clientName = '';
        },
        /**
         * событие клика по кнопке удалить клиента
         * @property {object}  item - выбранный клиент
         */
        async onClickRemoveClient(item){
            if(confirm("Вы уверены что хотите удалить '" + item.name + "'? Удалится вся аналитика связанная с этим клиентом.")){
                this.isUpdatingList = true;
                try {
                    let {data = []} = await serviceApi.post(routeClientRemove, {client_id: item.id});
                    if(data.message){
                        // alert(data.message);
                    }
                    this.clients.forEach((value, index) => {
                        if(value.id === item.id){
                            this.clients.splice(index, 1);
                        }
                    })
                }
                catch(error) {
                    if (error.message === 'not server')
                        alert('Извините, сервер временно недоступен');
                }
                this.isUpdatingList = false;
            }
        },
        /**
         * событие закрытие модального окна добавления клиента
         */
        closeModal() {
            this.isModal = false;
        },
        /**
         * событие добавления имени нового клиента
         * @param {string} clientName - название нового клиента
         */
        onSubmitClientAdd(clientName) {
            this.clientName = clientName;
            this.closeModal();
            this.postAddClient();
        },
        /**
         * тело запроса для добавления клиента
         * @returns {object}
         */
        reqBodyPostAddClient() {
            let reqBody = {
                editId: this.clientId,
                name: this.clientName,
                // user_id: this.activeUserId
            };
            return reqBody;
        },
        /**
         * запрос на добавление нового клиента
         * @async
         */
        async postAddClient() {
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeClientAdd, this.reqBodyPostAddClient());
                if(data.message){
                    alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        },
        /**
         * запрос на редактирование модели
         * @async
         * @property {array} client - редактируемый клиент
         */
        async onChangeModel(client){
          this.yOffset = window.pageYOffset;
            let postData = {
                editId: client['id'],
                editAttribute: client['attribute'],
                editValue: client['value']
            };
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeClientEdit, postData);
                if(data.message){
                    // alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        },
      async onChangeDropdown(data){
        this.onChangeModel({id: data.row.id, attribute: data.attribute, value: data.selected[0]});
      }
    }
}
</script>

<style lang="scss" scoped>
    .list-client__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-client__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-client__item_pointer{
        cursor: pointer;
    }
    .list-client__item_active{
        background: #dcdcdc;
    }
</style>